import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { L10nTranslationModule } from 'angular-l10n';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { ImageModule } from '@nano/common/image';
import { LangModule } from '../shared/lang/lang.module';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [CommonModule, L10nTranslationModule, NzGridModule, NzIconModule, NzTypographyModule, LangModule, ImageModule],
  declarations: [FooterComponent],
  exports: [FooterComponent]
})
export class FooterModule {
  constructor(@Optional() @SkipSelf() parentModule: FooterModule) {
    if (parentModule) {
      throw new Error('FooterModule is already loaded, import it only once.');
    }
  }
}
